export default class BillingInvoiceUrl {
  url: string;

  constructor(obj: any = {}) {
    this.url = obj.url || '';
  }

  public static of(obj: any = {}): BillingInvoiceUrl {
    return new BillingInvoiceUrl(obj);
  }
}
